const ANCHOR_GAP = 24;

export function formatDecisionNoteText({ question = '', answer = '' } = {}) {
  const choice = String(answer || '').trim();
  const prompt = String(question || '').trim();
  if (choice && prompt) return `${choice}\n${prompt}`;
  return choice;
}

export function findDecisionTextAnchor({
  answer = '',
  pinShapes = [],
  selectedBounds = null,
  viewport = null,
} = {}) {
  const needle = String(answer || '').trim().toLowerCase();
  const matches = needle
    ? pinShapes.filter((pin) => String(pin?.title || '').toLowerCase().includes(needle))
    : [];
  if (matches.length) {
    let maxX = -Infinity;
    let minY = Infinity;
    for (const pin of matches) {
      const w = Number(pin.w) || 300;
      maxX = Math.max(maxX, Number(pin.x) + w);
      minY = Math.min(minY, Number(pin.y));
    }
    if (Number.isFinite(maxX) && Number.isFinite(minY)) {
      return { x: maxX + ANCHOR_GAP, y: minY };
    }
  }
  if (selectedBounds && Number.isFinite(Number(selectedBounds.x))) {
    return {
      x: Number(selectedBounds.x) + Number(selectedBounds.w || 0) + ANCHOR_GAP,
      y: Number(selectedBounds.y),
    };
  }
  if (viewport) {
    return {
      x: (viewport.x || 0) + Math.max(40, (viewport.w || 900) * 0.08),
      y: (viewport.y || 0) + 60,
    };
  }
  return { x: 80, y: 80 };
}
